import { BotGraphType, BotStatus, BotType, FilterType } from "@shared/types";
import {
  TRAILING_PERCENT_ITEM_NAME,
  TRAILING_STOP_TYPE_ITEM_NAME,
  TRIGGER_TYPE_ITEM_NAME,
  TRIGGER_VALUE_ITEM_NAME,
} from "@shared/features/configuration/constants";
import { Steps } from "@shared/features/bots/BotForm/common/types";
import {
  myDCABotsFilters,
  myGridBotsFilters,
  mySignalsBotsFilters,
  myTradingViewBotsFilters,
} from "@shared/slices/filters.slice";
import { MyBotsSort } from "@shared/features/bots/types";

export const BOT_TYPES = [
  BotType.SIGNAL,
  BotType.ASAP,
  BotType.GRID,
  BotType.TRADING_VIEW,
];
export const BotGraphTypeToDisplay = {
  [BotGraphType.PROFIT_BY_DAY]: "Profit By Day",
  [BotGraphType.ACCUMULATING_PROFIT]: "Accumulated Profit",
} as const;

export const botsFilterTypeToTitle = {
  [FilterType.TIME_FRAME]: "Bot Create Time",
};

export const backtestingFilterTypeToTitle = {
  [FilterType.TIME_FRAME]: "Create Time",
};

export const VERTICAL_ACTIVE_TRADE_BREAKPOINT = 540;
export const ACTIVE_TRADE_ROWS_BREAKPOINT = 320;

export const BOT_HIGH_AMOUNT_MODAL_MESSAGE = [
  "Some of the buy orders might not get filled because the selected bot amount is higher than the available amount in your account.",
  "Continue and add funds later or go back and decrease the amount per trade",
];

export const BULK_UPDATE_BOTS_MUTATION_KEY = "bulkUpdateBots";

export const TRAILING_TOP_ITEM_NAME_TO_DATA_FIELD: Record<string, string> = {
  [TRAILING_STOP_TYPE_ITEM_NAME]: "type",
  [TRAILING_PERCENT_ITEM_NAME]: "value",
  [TRIGGER_TYPE_ITEM_NAME]: "trigger.type",
  [TRIGGER_VALUE_ITEM_NAME]: "trigger.value",
} as const;

export const TAB_TO_OBJECT_NAME: Record<Steps, string> = {
  [Steps.GENERAL]: "General",
  [Steps.ENTRIES]: "Entries",
  [Steps.TAKE_PROFITS]: "Take-Profits",
  [Steps.STOP]: "Stop",
  [Steps.ADVANCED]: "Advanced",
};

export const BOT_TYPE_TO_FILTERS_SLICE = {
  [BotType.ASAP]: myDCABotsFilters,
  [BotType.TRADING_VIEW]: myTradingViewBotsFilters,
  [BotType.SIGNAL]: mySignalsBotsFilters,
  [BotType.GRID]: myGridBotsFilters,
};

export const BOT_TYPE_TO_DISPLAY_NAME: Record<BotType, string> = {
  [BotType.ASAP]: "DCA",
  [BotType.TRADING_VIEW]: "TradingView",
  [BotType.SIGNAL]: "Signals",
  [BotType.GRID]: "Grid",
};

export const USING_CHANNEL_SETTING = "Using channel settings";

export const BOT_STATUS_TO_HIDE = [
  BotStatus.DELETED,
  BotStatus.EDITED,
  BotStatus.CLIENT_DELETED,
];
export const CHANNEL_CONFIGURATIONS_SORTS = new Set([
  MyBotsSort.NAME,
  MyBotsSort.CREATED,
]);
export const SIGNALS_BOTS_SORTS = new Set([
  MyBotsSort.LAST_TRADE_OPENED,
  MyBotsSort.NAME,
  MyBotsSort.TOTAL_PROFIT,
  MyBotsSort.CLOSED_TRADES,
  MyBotsSort.OPEN_TRADES,
  MyBotsSort.SYMBOL,
  MyBotsSort.CREATED,
  MyBotsSort.AMOUNT,
]);

export const INVALID_PUBLIC_BOT_MESSAGE =
  "The requested bot link is invalid and cannot be viewed.";
export const GENERAL_PUBLIC_BOT_ERROR_MESSAGE =
  "Something went wrong while fetching the bot details. Please try again later or contact support.";
export const PRIVATE_PUBLIC_BOT_MESSAGE =
  "This bot is no longer public and cannot be viewed.";

export const FIRST_ENTRY_AS_MARKET_FORM_ITEM_TITLE = "First Entry as Market";
export const OLD_FIRST_ENTRY_AS_MARKET_FORM_ITEM_TITLE = "First Entry Grace";

export const USD_ALTERNATIVE_PAIRS = ["USDT", "USD", "USDC"];
